import { Constants } from "../model/Constants";
import { Timeout } from "../util/Misc";
import {messagingtopbarRender} from "./templates/renders/messagingtopbar";

/**
 * MessagingTopBar custom element , this gets displayed in the top of the chat loayout
 * @type {{template, onHoverClick(*): void, created(): void, tagName: string, updateLogo(*=): void, updateTitle(*=): void, hideMaterial(): void,setChatStarted():void,emailRequested():void}}
 */
const MessagingTopBar: any = {
    tagName: "messaging-top-bar",
    renderer: messagingtopbarRender,
    initialize(options) {
        initComponent(options);
    },
    created() {
        /**
         * @type {HTMLElement}
         */
        this.topBarEL = this.el.firstChild;
        this.leftBar = this.topBarEL.querySelector(".top-bar-left");
        const bridge = this.$app.getBridge();

        if (bridge) {
            bridge.addDrag(this.topBarEL);
        }
    },
    hideMaterial() {
        const materialCont = this.topBarEL.querySelector(".top-bar-material-container");
        window.raf(() => {
            if (materialCont) {
                materialCont.style.opacity = 0;
                this.topBarEL.classList.remove("top-bar-material");
                Timeout.set(() => {
                    materialCont.style.display = "none";
                    this.topBarEL.classList.remove("messaging-top-bar-material");
                    this.config.materialBarItems.forEach(item => {
                        if (item.type === "Logo") {
                            this.updateLogo(item);
                        }
                    });
                }, this.matHideDelay);
            }
        });
    },

    /**
     * Find and update the background image of  logo element in the top bar
     * @param {object} logoConfig
     */
    updateLogo(logoConfig) {
        window.raf(() => {
            let logoEl = this.leftBar.querySelector("[type='Logo']");

            if (!logoEl) {
                logoEl = document.createElement("topbar-element");
                logoEl.setAttribute("type", "Logo");
                this.leftBar.insertBefore(logoEl, this.leftBar.firstChild);
            }

            logoEl.udpateBackground(logoConfig);
        });
    },

    /**
     * Find and update the title of  title element in the top bar
     * @param {string} title
     */
    updateTitle(title) {
        window.raf(() => {
            let titleEl = this.leftBar.querySelector("[type='Title']");

            if (!titleEl) {
                titleEl = document.createElement("topbar-element");
                titleEl.setAttribute("type", "Title");
                this.leftBar.appendChild(titleEl);
            }

            titleEl.updateTitle(title);
        });
    },
    updateStatus(status, subStatus) {
        window.raf(() => {
            const statusEl = this.leftBar.querySelector("[type='Status']");

            if (statusEl) {
                statusEl.updateStatus(status, subStatus);
            }
        });
    },
    findItems() {
        if (!this.items) {
            /**
             *
             * @type {Array.<OverFlowItem> | Array.<TopBarElement>}
             */
            this.items = [...this.topBarEL.querySelectorAll("overflow-item")];
            this.items.push(...this.topBarEL.querySelectorAll("topbar-element"));
        }
    },
    toggleFullScreen(fsmode: any): void {
        this.findItems();
        this.items.forEach(el => {
            if (el.getAttribute("mode") === Constants.IS_FULL_SCREEN) {
                el.toggleFullScreenMode(fsmode);
            }
        });
    },
    onIconClick(e) {
        if (typeof e.currentTarget.onIconClick !== "undefined") {
            e.currentTarget.onIconClick(e);
        }
    },
};

/**
 * @export MessagingTopBar
 * @param {CIApp} appInstance
 * @return {{template, onHoverClick, (*): void, created, (): void, tagName: string, updateLogo, (*=): void, updateTitle, (*=): void, hideMaterial, (): void}}
 */
export default appInstance => {
    MessagingTopBar.$app = appInstance;
    return MessagingTopBar;
};

const initComponent = (options: any) => {
    const app = options.$app;
    const appConfig = app.getUIConfig();

    if (appConfig.topBarConfig) {
        const tpConfig = appConfig.topBarConfig;
        options.constants = {
            contStyle: tpConfig.topBarContainerStyles,
            barStyle: tpConfig.topBarStyles,
            extendStyle: tpConfig.extendedTopBarStyles,
            extendItemStyle: tpConfig.extendedTopBarItemStyles,
            config: tpConfig.topBarSettings || {},
            topBarIconStyle: tpConfig.iconStyles,
            matHideDelay: tpConfig.topBarMaterialHideDelay || 1000,
            dragMode: appConfig.appConfigProps.dragMode,
        };

        const config = options.constants.config;

        if (appConfig.overFlowMenus) {
            appConfig.overFlowMenus.forEach(({ position, items, menuStyle }) => {
                if (position == "TopBarLeft") {
                    config.leftOverFlowItems = items;
                    options.constants.leftOverFlowMenuStyle = menuStyle;
                } else if (position == "TopBarRight") {
                    config.rightOverFlowItems = items;
                    options.constants.rightOverFlowMenuStyle = menuStyle;
                }
            });
        }

        if (app.getSDKInstance().isPersistentWindow()) {
            if (config.leftOverFlowItems) {
                config.leftOverFlowItems = filterMinimize(config.leftOverFlowItems);
            } else if (config.rightOverFlowItems) {
                config.rightOverFlowItems = filterMinimize(config.rightOverFlowItems);
            }

            if (config.leftTopBarItems) {
                config.leftTopBarItems = filterMinimize(config.leftTopBarItems);
            }

            if (config.centerTopBarItems) {
                config.centerTopBarItems = filterMinimize(config.centerTopBarItems);
            }

            if (config.rightTopBarItems) {
                config.rightTopBarItems = filterMinimize(config.rightTopBarItems);
            }

            if (config.extendedTopBarItems) {
                config.extendedTopBarItems = filterMinimize(config.extendedTopBarItems);
            }
        }

        if (config.leftTopBarItems) {
            config.leftTopBarItems.forEach(({ type, ...vals }) => {
                if (type == "Status") {
                    app.statusItems = vals; // eslint-disable-line no-param-reassign
                }
            });
        }
    }
};

function filterMinimize(objArrays) {
    return objArrays.filter(({ type }) => type !== "Minimize");
}
